// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__35VH2","content":"styles_content__2tr4B","selectAll":"styles_selectAll__2SG7L"};